// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "application." + "7c3897ad6300392a0c0e" + ".css";
};